import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const Index = () => {
  const { authUser } = useAuth();
  const { batchName, batchId, programName } = authUser?.activeSession || {};

  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTimelineByBatchId = async () => {
      try {
        setLoading(true);
        const data = await api.getTimelineByBatchId({ batchId });
        setTimeline(data);
      } catch (error) {
        console.error('Error fetching timeline:', error);
      } finally {
        setLoading(false);
      }
    };
    getTimelineByBatchId();
  }, [batchId]);

  return (
    <div className='row g-4'>
      {/* Header Card */}
      <div className='col-12'>
        <div className='card card-body border-0 shadow-sm rounded-4'>
          <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3'>
            <div className='d-flex align-items-center gap-3'>
              <div
                className='bg-primary bg-opacity-10 d-flex align-items-center justify-content-center rounded-3'
                style={{ width: '40px', height: '40px' }}
              >
                <i className='bi bi-speedometer2 text-primary fs-5'></i>
              </div>
              <div>
                <h1 className='h5 fw-bold mb-0 text-dark'>Dashboard</h1>
                <p className='text-muted mb-0 d-none d-lg-block' style={{ fontSize: '0.75rem' }}>
                  {programName || '-'}
                </p>
              </div>
            </div>
            <span className='badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2 fw-bold' style={{ fontSize: '0.75rem' }}>
              <i className='bi bi-collection-play-fill me-1'></i>
              Batch {batchName}
            </span>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className='col-12 col-lg-6'>
        <div className='card card-body border-0 shadow-sm rounded-4'>
          <div className='d-flex align-items-center gap-3 mb-4'>
            <div
              className='bg-primary bg-opacity-10 d-flex align-items-center justify-content-center rounded-3'
              style={{ width: '36px', height: '36px' }}
            >
              <i className='bi bi-calendar-week text-primary fs-6'></i>
            </div>
            <h2 className='h6 fw-bold mb-0 text-dark'>Timeline Magang CLP</h2>
          </div>

          {loading ? (
            <div className='d-flex justify-content-center align-items-center py-5'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : timeline.length === 0 ? (
            <div className='text-center py-5'>
              <div className='text-muted mb-3 opacity-25'>
                <i className='bi bi-inbox fs-1'></i>
              </div>
              <p className='text-muted small mb-0'>
                Belum ada data timeline untuk batch ini
              </p>
            </div>
          ) : (
            <div className='list-group'>
              {timeline.map((item, key) => {
                const isActive = item.activeStatus.status;
                const badgeClass = isActive
                  ? 'bg-primary bg-opacity-10 text-primary'
                  : 'bg-secondary bg-opacity-10 text-secondary';
                const iconClass = isActive
                  ? 'bi bi-play-circle-fill text-primary'
                  : 'bi bi-check-circle-fill text-success';

                return (
                  <label
                    className={`list-group-item d-flex gap-3 align-items-center py-3 px-0 border-0 border-bottom ${
                      !isActive ? 'bg-light bg-opacity-50' : ''
                    }`}
                    key={key}
                  >
                    <i className={`${iconClass} fs-5`}></i>
                    <div className='flex-grow-1'>
                      <strong className='d-block text-dark mb-1 small'>
                        {item.title}
                      </strong>
                      <small className='text-muted extra-small'>
                        {item.startDate} – {item.endDate}
                      </small>
                    </div>
                    <span className={`badge rounded-pill px-2 py-1 fw-semibold extra-small ${badgeClass}`}>
                      {item.activeStatus.message}
                    </span>
                  </label>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <style>{`
        .extra-small { font-size: 0.7rem; }
      `}</style>
    </div>
  );
};

export default Index;
